// extracted by mini-css-extract-plugin
module.exports = {"form":"form-module--form--3MTTk","submit":"form-module--submit--1Od2Z","select":"form-module--select--1w_S9"};